import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import ImageUploading from "react-images-uploading";

import {
  deleteExistingUserImage,
  updateAssetPrimary,
  uploadNewUserImage,
} from "../../../../store/actions/talents";
import { personTypeUUID } from "../../../../constants";
import trash from "../../../../assets/svg/trash.svg";
import box from "../../../../assets/svg/box.svg";
import checkBoxSquare from "../../../../assets/svg/checkBoxSquare.svg";

const UserImageUploader = (props) => {
  const {
    photos,
    triggerAddImage,
    isTalentView,
    newTalentId,
    companyUUID,
    id,
    triggerDeleteExistingAsset,
    triggerAssetPrimary,
    isTalentRegister,
  } = props;

  const baseUrl = process.env.REACT_APP_API_URL;
  const [imageIndex, setImageIndex] = useState([]);
  const MAX_IMAGES = 5;

  const setImageFileObject = (image, i) => {
    const personId = isTalentView ? id : newTalentId;

    if (image.data_url && image.file) {
      const actualPayload = {
        companyId: companyUUID,
        personId: personId,
        asset: image.file,
        isTalentView: isTalentView,
        isRegister: isTalentRegister,
      };

      const payload = {
        actualPayload: actualPayload,
        onSuccess: () => {
          setImageIndex((prevIndex) => [...prevIndex, i]);
        },
        onError: () => {},
      };
      triggerAddImage(payload);
    }
  };

  const updateToPrimary = (photoData) => {
    const payload = {
      actualPayload: {
        uuid: id,
        person_type_uuid: personTypeUUID,
        primary_photo_attribute_uuid: photoData?.attributeUUID,
      },
      onSuccess: () => {},
      onError: () => {},
    };
    triggerAssetPrimary(payload);
  };

  const deleteExistingImageFileObject = (photoData) => {
    const actualPayload = {
      companyId: companyUUID,
      assetUUID: photoData?.assetUUID,
    };

    if (photoData?.attributeUUID) {
      actualPayload.attributeUUID = photoData?.attributeUUID;
    }

    const payload = {
      actualPayload: actualPayload,
      onSuccess: () => {},
      onError: () => {},
    };
    triggerDeleteExistingAsset(payload);
  };

  const remainingUploadSlots = useMemo(() => {
    const currentTotalImages = photos.length;
    return MAX_IMAGES - currentTotalImages;
  }, [photos.length, imageIndex.length]);

  return (
    <div className="bg-white">
      {photos.map((photo, i) => {
        const element = baseUrl + photo?.fileLink;
        const isPrimary = photo?.primary;

        const primaryIcon = isPrimary ? checkBoxSquare : box;
        const primaryClass = isPrimary
          ? "w-6 h-6 opacity-90"
          : "w-6 h-6 cursor-pointer hover:opacity-80";

        const trashClass = isPrimary
          ? "w-6 h-6 opacity-40 cursor-not-allowed"
          : "w-6 h-6 cursor-pointer hover:opacity-80";

        const handlePrimaryClick = () => {
          if (!isPrimary) updateToPrimary(photo);
        };

        const handleDeleteClick = () => {
          if (!isPrimary) deleteExistingImageFileObject(photo);
        };
        return (
          <div
            key={photo?.assetUUID}
            className="relative mb-4 bg-catskill"
          >
            <img
              src={element}
              alt=""
              className="w-[350px] h-[350px] object-contain"
            />

            {/* ICON WRAPPER */}
            <div
              className="
                absolute bottom-2 right-2 
                bg-white rounded-lg shadow 
                flex items-center gap-3 
                p-2 z-10
              "
              style={{ paddingRight: "12px" }}
            >
              <button
                type="button"
                onClick={handlePrimaryClick}
                disabled={isPrimary}
                className="p-0 bg-transparent border-none disabled:cursor-not-allowed"
                data-tooltip-content={
                  isPrimary ? "Primary photo" : "Set as profile photo"
                }
              >
                <img
                  src={primaryIcon}
                  alt={isPrimary ? "Primary photo" : "Set as primary"}
                  className={primaryClass}
                />
              </button>

              <button
                type="button"
                onClick={handleDeleteClick}
                disabled={isPrimary}
                className="p-0 bg-transparent border-none disabled:cursor-not-allowed"
                data-tooltip-content={
                  isPrimary ? "Cannot delete primary picture" : "Delete picture"
                }
              >
                <img
                  src={trash}
                  alt={isPrimary ? "cannot delete" : "delete"}
                  className={trashClass}
                />
              </button>
            </div>
          </div>
        );
      })}

      <ImageUploading
        multiple
        value={[]}
        onChange={(imageList, addUpdateIndex) =>
          imageList.forEach((image, idx) =>
            setImageFileObject(image, addUpdateIndex[idx])
          )
        }
        maxNumber={MAX_IMAGES}
        dataURLKey="data_url"
      >
        {({ onImageUpload }) => (
          <>
            {Array.from({ length: remainingUploadSlots > 0 ? remainingUploadSlots : 0 }).map((_, i) => {
              const slotIndex = photos.length + i;

              if (imageIndex.includes(slotIndex)) {
                return null;
              }

              return (
                <div
                  key={slotIndex}
                  onClick={onImageUpload}
                  className="mb-1 flex cursor-pointer"
                >
                  <div
                    style={{ height: 350, width: 350, background: "#E9E9E9" }}
                    className="flex items-center justify-center hover:bg-gray-200 transition"
                  >
                    <svg
                      className="svg-circleplus h-7 -ml-5 stroke-black"
                      viewBox="0 0 100 100"
                    >
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="none"
                        strokeWidth="7.5"
                      ></circle>
                      <line x1="32.5" y1="50" x2="67.5" y2="50" strokeWidth="5"></line>
                      <line x1="50" y1="32.5" x2="50" y2="67.5" strokeWidth="5"></line>
                    </svg>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </ImageUploading>
    </div>
  );
};

const mapStateToProps = (state) => ({
  photos: state.talent.photos || [],
  newTalentId: state.talent.newTalentId,
  companyUUID: state.talent.companyUUID,
});

const mapDispatchToProps = {
  triggerAddImage: uploadNewUserImage,
  triggerDeleteExistingAsset: deleteExistingUserImage,
  triggerAssetPrimary: updateAssetPrimary,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserImageUploader);